export default "__VITE_ASSET__DVp_5JI7__"